export default __webpack_public_path__ + "static/media/Karageorgiou.bb06b08a.png";